import purple from "@material-ui/core/colors/purple";
import indigo from "@material-ui/core/colors/indigo";
import blue from "@material-ui/core/colors/blue";
import green from "@material-ui/core/colors/green";
import yellow from "@material-ui/core/colors/yellow";
import orange from "@material-ui/core/colors/orange";
import red from "@material-ui/core/colors/red";

const RECORD_SHADE = 200;

export const RecordColor = {
  Purple: purple[RECORD_SHADE],
  Indigo: indigo[RECORD_SHADE],
  Blue: blue[RECORD_SHADE],
  Green: green[RECORD_SHADE],
  Yellow: yellow[RECORD_SHADE],
  Orange: orange[RECORD_SHADE],
  Red: red[RECORD_SHADE],
  Default: "",
};

export const DARK_RECORD_SHADE = 500;

export const DarkRecordColor = {
  Purple: purple[DARK_RECORD_SHADE],
  Indigo: indigo[DARK_RECORD_SHADE],
  Blue: blue[DARK_RECORD_SHADE],
  Green: green[DARK_RECORD_SHADE],
  Yellow: yellow[700],
  Orange: orange[DARK_RECORD_SHADE],
  Red: red[DARK_RECORD_SHADE],
  Default: "",
};

const COLUMN_SHADE = 100;

export const ColumnColor = {
  Purple: purple[COLUMN_SHADE],
  Indigo: indigo[COLUMN_SHADE],
  Blue: blue[COLUMN_SHADE],
  Green: green[COLUMN_SHADE],
  Yellow: yellow[COLUMN_SHADE],
  Orange: orange[COLUMN_SHADE],
  Red: red[COLUMN_SHADE],
  Default: "",
};

export const DARK_COLUMN_SHADE = 400;

export const DarkColumnColor = {
  Purple: purple[DARK_COLUMN_SHADE],
  Indigo: indigo[DARK_COLUMN_SHADE],
  Blue: blue[DARK_COLUMN_SHADE],
  Green: green[DARK_COLUMN_SHADE],
  Yellow: yellow[700],
  Orange: orange[DARK_COLUMN_SHADE],
  Red: red[DARK_COLUMN_SHADE],
  Default: "",
};
